export default __webpack_public_path__ + "static/media/background1.be057fe1.png";